import { addStyles } from 'ethcss'
import { grid, item, IStyles, colors, color, palette } from 'theme'
import { indents, layers } from 'blocks.app/config'
import { mediaCSS } from 'theme'
import { defaultThemeStyles } from 'blocks.app/sidebar/Sidebar-theme'
import 'blocks.simple/animation/animation.css'

const filesStyles: IStyles = {
    filterWrapper: {
        marginRight: -grid.mr_md['margin-right'],
    },
    filter: {
        ...item.white,
    },
    buttonClose: {
        zIndex: layers.drop,
        ...grid.flex,
        ...grid.justifyEnd,
        ...grid.pb_miniPlus,
    },
    link: {
        textDecoration: 'underline',
        cursor: 'pointer',
        color: colors.blueAccent,
    },
    menuItem: {
        ...grid.p_mini,
        cursor: 'pointer',
        ...item.transitionErase,
        textAlign: 'center',
        color: `var(--var-module-sidebar-component-sidebar-style-menuTextHover, ${defaultThemeStyles.menuTextHover})`,
        display: 'block',
        textDecoration: 'none',
        '&:hover': {
            color: `var(--var-module-sidebar-component-sidebar-style-menuText, ${defaultThemeStyles.menuText})`,
        },
    },
    breadcrumbs: {
        ...grid.pl_mdPlus,
        marginLeft: -grid.m_mdPlus['margin'],
        marginTop: '10px',
        width: `calc(100% + ${2 * grid.m_mdPlus['margin']}px)`,
        [mediaCSS.tabMini]: {
            marginTop: -grid.m_mini['margin'],
        },
    },
    breadcrumbs_x: {
        paddingLeft: '0px',
    },
    button: {
        position: 'absolute',
        bottom: indents.md,
        left: 'calc(50% - 55px)',
    },
    modalWrapper: {
        ...grid.full,
        ...grid.rowCenter,
    },
    modalInner: {
        ...grid.w30,
        [mediaCSS.tab]: {
            ...grid.w60,
        },
        [mediaCSS.tabMini]: {
            ...grid.w90,
        },
        backgroundColor: `var(--var-module-sidebar-component-sidebar-style-background, ${defaultThemeStyles.background})`,
        boxShadow: '0 19px 38px rgb(0 0 0 / 30%), 0 15px 12px rgb(0 0 0 / 22%)',
        ...item.rounded_full_mini,
        overflow: 'hidden',
        position: 'relative',
        minHeight: 300,
    },
    overflow: {
        overflowY: 'auto',
    },
    maxHeight: {
        maxHeight: '80vh',
    },
    aiWrapper: {
        background: colors.greyLight,
        width: '30vw',
        height: '60vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        [mediaCSS.tab]: {
            width: '80vw',
        },
    },
    catalogWrapper: {
        width: '30vw',
        height: '60vh',
        display: 'flex',
        justifyContent: 'center',
    },
    grey: {
        color: colors.grey,
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: `30px solid ${colors.white}`,
        borderTop: `30px solid ${colors.blueAccent}`,
        borderRadius: '50%',
        width: '300px',
        height: '300px',
        animation: 'spin 1s linear infinite',
    },
    loaderText: {
        position: 'absolute',
    },
    aiContentImg: {
        maxWidth: '100%',
        maxHeight: '45vh',
    },
    hidden: {
        visibility: 'hidden',
    },
    errorInputText: {
        color: 'red',
        fontSize: '12px',
    },
    propertyModal: {
        width: 450,
        [mediaCSS.tab]: {
            width: 300,
        },
    },
    contentPropertiesModal: {
        width: 600,
        backgroundColor: colors.white,
        borderRadius: 14,
        overflow: 'hidden',
        boxShadow: '0 19px 38px rgb(0 0 0 / 30%), 0 15px 12px rgb(0 0 0 / 22%)',
        color: colors.blackLight,
    },
    contentPropertiesHeader: {
        ...grid.row,
        ...grid.justify,
        ...grid.normalCenter,
        padding: '24px 24px 8px 24px',
    },
    contentPropertiesTitle: {
        fontSize: 24,
        fontWeight: 600,
        color: color.fontDarkUltraHigh,
    },
    contentPropertiesClose: {
        cursor: 'pointer',
    },
    contentPropertiesBody: {
        padding: '8px 24px 24px 24px',
    },
    contentPropertiesSectionTitle: {
        fontSize: 20,
        fontWeight: 600,
        lineHeight: '28px',
        margin: '12px 0 8px',
        color: color.fontDarkUltraHigh,
        '&:first-child': {
            marginTop: 0,
        },
    },
    contentPropertiesGrid: {
        ...grid.col,
    },
    contentPropertiesRow: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        alignItems: 'start',
        columnGap: 16,
        padding: '4px 0',
        fontSize: 16,
        color: color.fontDarkMedium,
        '& > span:last-child': {
            minWidth: 0,
            wordBreak: 'break-word',
            color: color.fontDarkUltraHigh,
        },
    },
    contentPropertiesValueWithAction: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        minWidth: 0,
    },
    contentPropertiesAction: {
        color: `${color.blue} !important`,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    contentPropertiesInput: {
        width: '100%',
        marginBottom: 8,
    },
    contentPropertiesCommentText: {
        fontSize: 16,
        lineHeight: '24px',
        marginBottom: 10,
    },
    contentPropertiesFooter: {
        borderTop: `1px solid ${color.borderDarkPrimary}`,
        padding: '12px 20px',
    },
    contentPropertiesCloseButton: {
        minWidth: 90,
        backgroundColor: palette.white,
    },
    sidebarWrapper: {
        marginTop: 24,
    },
}

addStyles(filesStyles)
export default filesStyles
